import React from 'react'
import clsx from 'clsx'

import styles from '../../Navbar.module.scss'

interface NavItemProps {
  className?: string
  href?: string
  title?: string
  isActive?: boolean
}

export const NavItem: React.FC<NavItemProps> = ({
  isActive = false,
  className,
  href,
  title,
}) => {
  return (
    <li className={className}>
      <a
        href={href}
        className={clsx(styles['hds-nav__item'], {
          [styles.active]: isActive,
        })}
      >
        {title}
      </a>
    </li>
  )
}
